import React from 'react';
import { Hero } from '../components/Hero';
import { ImageShowcase } from '../components/ImageShowcase';
import { Services } from '../components/Services';
import { Portfolio } from '../components/Portfolio';
import { About } from '../components/About';
import { Testimonials } from '../components/Testimonials';
import { Contact } from '../components/Contact';
export function LandingPage() {
  return <main data-id="element-230">
      <Hero data-id="element-231" />
      <ImageShowcase data-id="element-232" />
      <Services data-id="element-233" />
      <Portfolio data-id="element-234" />
      <About data-id="element-235" />
      <Testimonials data-id="element-236" />
      <Contact data-id="element-237" />
    </main>;
}